import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-fullscreen-exit" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-fullscreen" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import {useEnterFullscreen, useExitFullscreen, useIsInFullscreen} from "@/composables/fullscreen";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isInFullscreen = useIsInFullscreen()
const enterFullscreen = useEnterFullscreen()
const exitFullscreen = useExitFullscreen()

const isFullscreen = isInFullscreen()


return (_ctx: any,_cache: any) => {
  return (_unref(isFullscreen))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(exitFullscreen) && _unref(exitFullscreen)(...args)))
      }, _hoisted_2))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "round",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(enterFullscreen) && _unref(enterFullscreen)(...args)))
      }, _hoisted_4))
}
}

})